import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-display-expandable',
    templateUrl: './his-display-expandable.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayExpandableComponent {
    value = '';
    display = '';
    expanded = false;
    limit = 100;

    @Input( 'value' )
    set _value_( val: string ) {
        this.value = val;
        this.update();
    }

    @Input( 'expanded' )
    set _expanded_( val: boolean ) {
        this.expanded = val;
        this.update();
    }

    @Input( 'limit' )
    set _limit_( val: number ) {
        this.limit = val;
        this.update();
    }

    toggle( e: Event ): void {
        this.expanded = !this.expanded;
        this.update();
    }

    update(): void {
        if ( this.expanded ) {
            this.display = this.value;
        } else {
            this.display = this.value.substring( 0, this.limit );
        }
    }
}
